/**
 *  Model List
 */

export function init() {

  // Init data for SAV link when assitance Floor is load
  let savLinks = null;
  cube.event.on(`async-content:AssistanceFloor`, () => {
    savLinks = JSON.parse(cube.$('.js-sav').dataset.savLinks);
  });

  // On Model change, display color in the title
  // hide the title if no color is supplied
  cube.event.on('modelChanged', newModelId => {

    const convContext = cube.$('.product-display__conversion-zone');

    // Update Slick status of thumbnail
    convContext.$$('.slider-nav-product-visual .slick-slide').classList.remove('slick-current');
    if (newModelId) convContext.$(`.slider-nav-product-visual [data-model-id="${newModelId}"]`).closest('.slick-slide').classList.add('slick-current');

    // Update color text display (or hide the title if none is provided)
    const modelColor = cube.$('.slick-current.model-selection').dataset.color;
    if (modelColor) {
      convContext.$('.model-color').textContent = modelColor;
      convContext.$('.model-title').classList.remove('hidden');
    } else
      convContext.$('.model-title').classList.add('hidden');

    // Change SAV Link
    if(savLinks !== null && savLinks.length) {
      savLinks.forEach((currentSavLink) => {
        if(currentSavLink.id === newModelId) {
          cube.$('.js-sav').setAttribute('href', currentSavLink.supportLink);
        }
      });
    }

    // Display/hide customizable button
    if(cube.$id('personalize-btn')) {
      if(cube.$('.model-selection.slick-current').dataset.custom === 'true') {
        const customUrl = cube.$('.model-selection.slick-current').dataset.customLink;
        cube.$id('personalize-btn').classList.add('buying-zone__personalize-btn--show');
        cube.$id('personalize-btn').setAttribute('href', customUrl);
      } else {
        cube.$id('personalize-btn').classList.remove('buying-zone__personalize-btn--show');
      }
    }

    /*
        Use to reload floors on model changed if reloadOnModelChange is true.
        - NON ASYNC CONTAINER : Floor reloading with new model information.
        - ASYNC CONTAINER     : Push model information on floor dataset parameters.
    */
    const floorsToReload = cube.$$('.non-async-container, .async-container');

    floorsToReload.forEach(floorToReload => {
      if(floorToReload.dataset.reloadModel === 'true') {
        floorReloader(floorToReload);
      }
    });

    function handleNavLinkDisplay(elt, visible) {
      const floorLink = cube.$(`#internal-navigation a[href="#${elt.id}"]`) || null;
      const listItem = floorLink ? floorLink.closest('li') : null;

      if (listItem) {
        if (visible)
          listItem.classList.add('description-product-nav--visible');
        else
          listItem.classList.remove('description-product-nav--visible');
      }

    }

    function floorReloader(elt) {
      const url = `asyncCartridgeLoad?contentPath=${elt.getAttribute(
        'data-async-content'
      )}&params=A=m-${newModelId}&mc=${newModelId}`;

      cube.ajax
        .get(url)
        .onSuccess(resp => {

          if (resp.length > 0 && typeof resp !== 'object') {
            // Response traitment
            if (cube.$id(elt.id)) {
              handleNavLinkDisplay(cube.$id(elt.id), true);
              cube.$id(elt.id).innerHTML = resp;
            }
            // Send event to init elements
            cube.event.send('floor-reload');
            // Update pictures behavior
            cube.lazyload.updateObserver();

          } else if (cube.$id(elt.id)) {
            handleNavLinkDisplay(cube.$id(elt.id, false));
            cube.$id(elt.id).innerHTML = '';
          }

        })
        .call();
    }



  });
}



// WEBPACK FOOTER //
// ./src/catalog/product-details/model-list.js